import type { PageFaq } from "@/data/pageFaqs";

export function PageFaqs({ faqs, heading = "Common questions" }: { faqs: PageFaq[]; heading?: string }) {
  return (
    <section className="bg-background py-24">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <span className="eyebrow">FAQ</span>
        <h2 className="mt-4 font-serif text-3xl text-foreground sm:text-4xl">{heading}</h2>
        <dl className="mt-10 space-y-6">
          {faqs.map((f) => (
            <div key={f.q} className="card-panel">
              <dt><h3 className="font-serif text-lg text-foreground">{f.q}</h3></dt>
              <dd className="mt-3 text-charcoal">{f.a}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
